var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStoreFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19269 6.93865C1.14614 5.96097 1.92625 5.14282 2.90504 5.14282H21.595C22.5738 5.14282 23.3539 5.96097 23.3074 6.93865L22.6912 19.8773C22.6042 21.7054 21.0967 23.1428 19.2666 23.1428H5.23351C3.40337 23.1428 1.89587 21.7054 1.80882 19.8773L1.19269 6.93865Z",
    fill: "#004FEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96422 6C7.96422 3.63307 9.883 1.71429 12.2499 1.71429C14.6169 1.71429 16.5356 3.63307 16.5356 6",
    stroke: "#004FEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5358 9.42859C16.5358 11.7955 14.617 13.7143 12.2501 13.7143C9.88313 13.7143 7.96436 11.7955 7.96436 9.42859",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStoreFocus);
export default __webpack_public_path__ + "static/media/menu_store_focus.8207a23f9e00eb9a305b7b9f91e6b842.svg";
export { ForwardRef as ReactComponent };